import React, { useState } from "react";
import { Button, Divider,Drawer } from "antd";
import PastOrdersDetails from "./PastOrdersDetails";

interface OrderCardProps {
  imageUrl: string;
  restaurantName: string;
  address: string;
  dateTime: string; // formatted like "21 Jan 2023, 07:37 PM"
  orderId: string;
  status: string; // "Delivered"
  items: string; // e.g. "1 x Chicken Cheese Burrito, 2 x Nashville Spice Tacos"
  totalCost: string; // e.g. "$42.99"
}

const PastOrders = () => {

    const [open, setOpen] = useState(false);
    const [type, setType] = useState("rate");

  const showDrawer = () => {
    setType("rate")
    setOpen(true);
  };

  const showDrawerHelp = () => {
    setType("help")
    setOpen(true);
  };
  const showDrawerDetails = () => {
    setType("details")
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  return (
    <div>
    <div
      style={{
        maxWidth: 1044,
        border: "1px solid #00000033",
        display: "flex",
        flexDirection: "column",
        padding: "20px",
        marginBottom: "20px",
      }}
    >
      {/* Top Row */}
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        {/* Left: image + info */}
        <div style={{ display: "flex" }}>
          <img
            src={'/Home/newBg.svg'}
            alt={"restaurantName"}
            style={{
              width: 190,
              height: 123,
              objectFit: "cover",
              borderRadius: 4,
            }}
          />
          <div style={{ marginLeft: 25 }}>
            <div
              style={{
                fontFamily: "Inter",
                fontWeight: 600,
                fontSize: 20,
                opacity: 0.9,
              }}
            >
              {"The Burrito Company"}
            </div>
            <div
              style={{
                fontFamily: "Inter",
                fontWeight: 500,
                opacity: 0.5,
              }}
            >
              Colorado Springs
            </div>
            <div
              style={{
                fontFamily: "Inter",
                fontSize: 18,
                fontWeight: 500,
                opacity: 0.5,
              }}
            >
              21 Jan 2023, 07:37 PM  •  Order ID: 7521123
            </div>
          </div>
        </div>

        {/* Right: status */}
        <div
          style={{
            fontFamily: "Inter",
            color: "#009E19",
            fontSize: 18,
            fontWeight: 600,
            opacity: 0.9,
            alignSelf: "flex-start",
          }}
        >
          {"Delivered"}
        </div>
      </div>

      <Divider style={{ margin: "20px 0" }} />

      {/* Middle Row */}
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div
          style={{
            fontFamily: "Inter",
            fontWeight: 600,
            fontSize: 18,
            opacity: 0.7,
          }}
        >
          {"items"}
        </div>
        <div
          style={{
            fontFamily: "Inter",
            fontWeight: 500,
            fontSize: 18,
            opacity: 0.5,
          }}
        >
          Total Cost: {"$ 349.0"}
        </div>
      </div>

      {/* Footer Row */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginTop: 20,
        }}
      >
        <Button
          type="primary"
          style={{
            background: "#C32340",
            border: "none",
            height: 40,
            fontWeight: 600,
          }}
          onClick={showDrawer}
        >
          Reorder
        </Button>
        <div
          className="help-cta"
          onClick={showDrawerHelp}
        >
          Help
        </div>
        <div
          style={{
            marginLeft: "auto",
            fontFamily: "Inter",
            fontSize: 18,
            fontWeight: 500,
            textDecoration: "underline",
            cursor: "pointer",
            color: "#000",
          }}
          onClick={showDrawerDetails}
        >
          View details
        </div>
      </div>
    </div>

    <Drawer
        title="Order ID: 7521123 "
        placement="right"
        closable={false}
        onClose={onClose}
        open={open}
        getContainer={false}
        className="past-order-drawer"
      >
       
       <PastOrdersDetails type={type}/>
       
      </Drawer>
    </div>
  );
};

export default PastOrders;
